import omit from "lodash/omit";
import qs from "qs";
import React, { useEffect, useMemo } from "react";
import { getQuarter, getYear } from "date-fns";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { Filter } from "~/features/filter";
import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";

import { APPEAL_FILTER_KEYS, appealsFilterFields } from "./fields";

// Дефолты старой формы (getDefaultValues в widgets/Filters/AppealsFilter):
// предыдущий квартал и его год, измерение «по дилеру», текущий дилер
// из sessionStorage.
const getDefaultParams = (): Record<string, string> => {
  const currentQuarter = getQuarter(new Date());
  const currentYear = getYear(new Date());
  const previousQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
  const previousYear = currentQuarter === 1 ? currentYear - 1 : currentYear;
  const defaults: Record<string, string> = {
    year: String(previousYear),
    quarter: String(previousQuarter),
    filterBy: FILTER_BY.DEALER,
  };
  const currentDealerId = sessionStorage.getItem("currentDealerId");
  if (currentDealerId) {
    defaults.filterItems = currentDealerId;
  }
  return defaults;
};

const AppealsFilter = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const fields = useMemo(() => appealsFilterFields(t), [t]);

  // Подставляем дефолты в URL при первом входе, если не заданы явно.
  useEffect(() => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const defaults = getDefaultParams();
    const missing = Object.keys(defaults).filter((key) => !params[key]);
    if (missing.length) {
      history.replace({
        search: qs.stringify({
          ...params,
          ...missing.reduce(
            (acc, key) => ({ ...acc, [key]: defaults[key] }),
            {},
          ),
        }),
      });
    }
  }, []);

  // Сброс возвращает дефолты — так работала старая форма, где при сбросе
  // заново применялись прошлый квартал, измерение «по дилеру» и текущий дилер.
  const handleReset = () => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const rest = omit(params, [...APPEAL_FILTER_KEYS, "page"]);
    history.replace({
      search: qs.stringify({ ...rest, ...getDefaultParams() }),
    });
  };

  return (
    <Filter.Root fields={fields} alwaysShow columns={5} onReset={handleReset} />
  );
};

export default AppealsFilter;
